import {emailValidation} from '../../_Global/js/utils';

/** Dynamic for validation for any Matrix form created.
 * Assumes one Matrix Form to be used per page and
 * for validation convenience, this automatically adds the form-matrix class name.
 */

/** Dynamic for validation for any Matrix form created.
 * Assumes one Matrix Form to be used per page and
 * for validation convenience, this automatically adds the form-matrix class name.
 */
export default function formMatrixValidation() {
    const formMatrix = document.querySelector('.form-matrix');

    const textInputMinLength = 2;
    // Assume same as textarea for now
    const textInputMaxLength = 160;

    let textareaLength = 0;
    const textareaInputMinLength = 2;
    const textareaInputMaxLength = 200;

    // Dynamically get the value from each textarea before Form Submission
    if (formMatrix) {
        initForm();
        formMatrix.addEventListener('submit', validateForm);
    }

    function initForm() {
        const formInputContainers = formMatrix.querySelectorAll('.sq-form-question');

        formInputContainers.forEach((formInputs) => {
            const textInput = formInputs.querySelector('input[type="text"]');
            const textareaInput = formInputs.querySelector('textarea');
            const selectInput = formInputs.querySelector('select');

            if (textInput) {
                const helperEl = document.createElement('p');
                helperEl.setAttribute('class', 'helper');
                textInput.closest('.sq-form-question-answer').append(helperEl);

                const helperContainer = formInputs.querySelector('.helper');
                const helperNote = formInputs.querySelector('.sq-form-question-note');

                helperContainer && helperNote && helperContainer.append(helperNote);
                helperContainer.style.justifyContent = helperContainer.children.length > 1 ? 'space-between' : 'flex-start';
            }

            if (textareaInput) {
                const helperEl = document.createElement('p');
                const counterEl = document.createElement('span');
                helperEl.setAttribute('class', 'helper');
                counterEl.setAttribute('class', 'char-counter');

                textareaInput.closest('.sq-form-question-answer').append(helperEl);

                const helperContainer = formInputs.querySelector('.helper');
                const helperNote = formInputs.querySelector('.sq-form-question-note');

                helperContainer && helperNote && helperContainer.append(helperNote);

                counterEl.innerHTML = `${textareaLength}/${textareaInputMaxLength}`;
                helperEl.append(counterEl);

                const hasOneChild = helperContainer.children.length === 1;
                const firstChildIsCharCounter = hasOneChild && helperContainer.children[0].className === 'char-counter';

                helperContainer.style.justifyContent = firstChildIsCharCounter ? 'flex-end' : 'space-between';

                textareaInput.addEventListener('input', function () {
                    textareaLength = textareaInput.value.trim().length;
                    counterEl.innerHTML = `${textareaLength}/${textareaInputMaxLength}`;
                });
            }

            if (selectInput && selectInput.value === '') {
                selectInput.style.borderColor = '#727683';
                selectInput.style.color = '#727683';
            }

            if (selectInput) {
                selectInput.addEventListener('change', function () {
                    selectInput.style.color = '#0b1c46';
                    selectInput.style.borderColor = '#0b1c46';
                });
            }
        });
    }

    function validateForm(e) {
        const formInputContainers = formMatrix.querySelectorAll('.sq-form-question');

        formInputContainers.forEach((formInputs) => {
            const textInput = formInputs.querySelector('input[type="text"]');
            const textareaInput = formInputs.querySelector('textarea');
            const selectInput = formInputs.querySelector('select');
            const radioInput = formInputs.querySelectorAll('input[type="radio"]');
            const checkboxInput = formInputs.querySelectorAll('input[type="checkbox"]');

            const emailField = formInputs.classList.contains('sq-form-question-email-address');
            const radioField = formInputs.classList.contains('sq-form-question-option-list');
            const checkboxField = formInputs.classList.contains('sq-form-question-tickbox-list');

            let radioGroupValid = false;
            let checkboxGroupValid = false;

            const charCounter = formInputs.querySelector('.char-counter');

            const existingErrorMessage = formInputs.querySelector('.client-validate');

            const removeErrorContainer = () => {
                existingErrorMessage.remove();
                formInputs.classList.remove('sq-form-question-error');

                if (selectInput) {
                    selectInput.style.color = '#0b1c46';
                    selectInput.style.borderColor = '#0b1c46';
                }
            };

            radioInput.forEach((radio) => {
                if (radio.checked) {
                    radioGroupValid = true;
                }
            });

            checkboxInput.forEach((checkbox) => {
                if (checkbox.checked) {
                    checkboxGroupValid = true;
                }
            });

            function displayInputError(el, message) {
                if (formInputs.style.display !== 'none') {
                    e.preventDefault();
                    const errorMessage = document.createElement('p');
                    const errorSpan = document.createElement('span');
                    errorMessage.setAttribute('class', 'sq-form-error client-validate');
                    errorSpan.append(message);
                    errorMessage.append(errorSpan);

                    if (!existingErrorMessage) {
                        if (radioField || checkboxField) {
                            formInputs.querySelector('.sq-form-question-answer').appendChild(errorMessage);
                            formInputs.querySelector('.sq-form-question-answer').classList.add('sq-form-question-error');
                        } else {
                            formInputs.appendChild(errorMessage);
                            formInputs.classList.add('sq-form-question-error');
                        }
                    }
                }
            }

            // Client side Validation displays above the Radio and Checkboxes while Server side will automatically displays below
            function displayChoiceInputError(el, message) {
                if (formInputs.style.display !== 'none') {
                    e.preventDefault();
                    const errorMessage = document.createElement('p');
                    const errorSpan = document.createElement('span');
                    errorMessage.setAttribute('class', 'sq-form-error client-validate choice--input');
                    errorSpan.append(message);
                    errorMessage.append(errorSpan);

                    if (!existingErrorMessage) {
                        if (radioField || checkboxField) {
                            formInputs.querySelector('fieldset').prepend(errorMessage);
                            formInputs.querySelector('fieldset').classList.add('sq-form-question-error');
                        } else {
                            formInputs.prepend(errorMessage);
                            formInputs.classList.add('sq-form-question-error');
                        }
                    }
                }
            }

            function clearInputError() {
                // Define individual validation functions
                const isTextValid = () =>
                    (!emailField && textInput && textInput.value.trim().length >= textInputMinLength && textInput.value.trim().length <= textInputMaxLength) ||
                    formInputs.style.display === 'none';

                const isEmailValid = () => emailField && textInput && emailValidation(textInput.value.toLowerCase().trim());

                const isTextareaValid = () =>
                    (textareaInput && textareaLength >= textareaInputMinLength && textareaLength <= textareaInputMaxLength) || formInputs.style.display === 'none';

                const isSelectValid = () => selectInput && (selectInput.value !== '' || formInputs.style.display === 'none');

                const isRadioValid = () => radioField && radioInput && radioGroupValid;

                const isCheckboxValid = () => checkboxField && checkboxInput && checkboxGroupValid;
                if (!existingErrorMessage) {
                    if (isSelectValid()) {
                        selectInput.style.color = '#0b1c46';
                        selectInput.style.borderColor = '#0b1c46';
                    }
                } else {
                    // Check if any of the inputs are valid
                    if (isTextValid() || isEmailValid() || isTextareaValid() || isSelectValid() || isRadioValid() || isCheckboxValid()) {
                        removeErrorContainer();
                    }
                }
            }

            function runValidation() {

                // Text Validation
                if (
                    !formInputs.classList.contains('sq-form-question-email-address') &&
                    textInput &&
                    !(textInput.value.trim().length >= textInputMinLength && textInput.value.trim().length <= textInputMaxLength)
                ) {
                    displayInputError(textInput, `Please enter between ${textInputMinLength} and ${textInputMaxLength} characters.`);
                } // Hidden Text to set value to ""
                else if (textInput && formInputs.style.display === 'none') {
                    textInput.value = '';
                }
                // Email Validation
                if (emailField && textInput && !emailValidation(textInput.value.toLowerCase().trim())) {
                    displayInputError(textInput, 'Please enter a valid email address.');
                }
                // Textarea Validation
                if (textareaInput && (textareaLength < textareaInputMinLength )) {
                    displayInputError(textareaInput, `Please enter your enquiry.`);
                } else if (textareaInput && !(textareaInput && textareaLength >= textareaInputMinLength && textareaLength <= textareaInputMaxLength)) {
                    displayInputError(textareaInput, `Please enter between ${textareaInputMinLength} and ${textareaInputMaxLength} characters.`);
                } // Hidden Textarea to set value to ""
                else if (textareaInput && formInputs.style.display === 'none') {
                    textareaInput.value = '';
                    charCounter.innerHTML = `0/${textareaInputMaxLength}`;
                }
                // Select Dropdown Validation
                if (selectInput && selectInput.value === '') {
                    displayInputError(selectInput, 'Please select a valid dropdown option.');
                    selectInput.style.borderColor = '#d01406';
                }
                // Hidden Select Dropdown to set value to ""
                else if (selectInput && formInputs.style.display === 'none') {
                    selectInput.value = '';
                }
                // Radio Validation
                if (radioField && radioInput && !radioGroupValid) {
                    displayChoiceInputError(radioInput, 'Please select one option.');
                }
                // Checkbox Validation
                if (checkboxField && checkboxInput && !checkboxGroupValid) {
                    displayChoiceInputError(checkboxInput, 'Please select at least one checkbox option.');
                }
                // Validations passed
                else {
                    clearInputError();
                }
            }

            runValidation();
        });
    }
}
